export default __webpack_public_path__ + "static/media/p1-1-1.ed79d1c0.png";